import { render, staticRenderFns } from "./MensagensWhatsappNaoLidas.vue?vue&type=template&id=821b74e4&"
import script from "./MensagensWhatsappNaoLidas.vue?vue&type=script&lang=js&"
export * from "./MensagensWhatsappNaoLidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports